import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c751c50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = {
  key: 0,
  class: "heading-xl"
}
const _hoisted_3 = {
  key: 1,
  class: "loading heading-sm"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 3,
  class: "default-help-resources"
}
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  class: "help-link",
  href: "tel:911"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "help-link",
  href: "tel:988"
}, "988", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "help-link",
  href: "tel:18002738255"
}, "800-273-8255", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobileWebView)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t('title')), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : (_ctx.headerHTML)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "get-help-resources",
            innerHTML: _ctx.headerHTML
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "tdoc-logo",
              src: "/img/teladoc-logo.png",
              alt: _ctx.$t('teladocLogoDescription')
            }, null, 8, _hoisted_6),
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t('text1')), 1),
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('call911')), 1),
              _createTextVNode(_toDisplayString(_ctx.$t('text2')), 1),
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.$t('text3')), 1),
              _hoisted_10,
              _createTextVNode(".")
            ])
          ]))
  ]))
}